export default __webpack_public_path__ + "static/mark-a29509b2fa34aeba53687a27a69d5a20.jpg";